import {defineStore} from "pinia";
import {createBaseStore} from "@/stores/base";

export const useScheduleAnnotationStore = defineStore('scheduleAnnotation', createBaseStore('/plananmerkungen/',
        {},
        {
            async getScheduleAnnotations(scheduleId) {
                try {
                    const response = await this.axios.get(`/plananmerkungen/?schedule=${scheduleId}`);
                    this.data = this.data.filter(s => s.schedule !== scheduleId).concat(response.data);
                } catch (e) {
                    console.log(e);
                }
            },
        },
        {
            scheduleAnnotationsForSchedule: (state) => {
                return (scheduleId) => {
                    return state.data.filter(s => s.schedule === scheduleId);
                }
            }
        }
    )
)